import(/* webpackMode: "eager" */ "/app/src/app/finance/debts/page.tsx");
